<template>
  <div>
    <div
      v-if="checkPermission(permissions, ['admin', 'edit'])"
      class="flex-end"
    >
      <Button
        :text="$lang.contentEdit"
        variant="primary"
        type="submit"
        class="mobile-width-percent-100"
        contentClass="mobile-flex-justify-content-center"
        @click="handleToggleShouldEdit"
      />
    </div>
    <FormWrapper
      v-if="
        getLoading ||
        (shouldEdit && checkPermission(permissions, ['admin', 'edit']))
      "
      wrapperClass="margin-top-16"
      bodyClass="padding-x-16 padding-top-16"
      :handleSubmit="handleSubmit"
      :loading="loading"
      :isSubmitButton="!getLoading"
    >
      <FormLoading :loading="getLoading" :count="2" class="padding-0">
        <TextEditor
          :label="$route.meta.label"
          :placeholder="$route.meta.label"
          :value="form.description"
          :toolbarItems="toolbarItems"
          name="description"
          id="description"
          rowClass="margin-top-16"
          :vuelidateObj="$v.form.description"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
      </FormLoading>
    </FormWrapper>
    <div
      v-else
      class="background-surface border--solid border--complementary-50 border-radius-8 padding-16 margin-top-16"
      v-html="form.description"
    />
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { required } from "vuelidate/lib/validators";
import {
  FormWrapper,
  FormLoading,
  TextEditor,
  Button,
} from "@/components/re-design/forms";
import {
  checkPermission,
  generateCurrentRoute,
  generateError,
  toastAlert,
} from "@/shared/utils";
import { getHelp, updateHelp } from "@/modules/home/services";
export default {
  mixins: [inputMixin],
  components: { FormWrapper, FormLoading, TextEditor, Button },
  validations() {
    return {
      form: {
        description: {},
      },
    };
  },
  data() {
    return {
      form: {
        description: null,
      },
      loading: false,
      getLoading: false,
      itemId: null,
      permissions: [],
      toolbarItems: [
        "heading",
        "alignment",
        "indent",
        "outdent",
        "|",
        "highlight",
        "fontFamily",
        "fontSize",
        "fontColor",
        "fontBackgroundColor",
        "|",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "code",
        "subscript",
        "superscript",
        "removeFormat",
        "|",
        "insertTable",
        "tableColumn",
        "tableRow",
        "mergeTableCells",
        "|",
        "blockQuote",
        "bulletedList",
        "numberedList",
        "todoList",
        "|",
        "imageUpload",
        "link",
        "undo",
        "redo",
      ],
      shouldEdit: false,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    checkPermission,
    async fetchData() {
      try {
        this.getLoading = true;
        this.form.description = null;
        const helpKey = generateCurrentRoute();
        const response = await getHelp(helpKey);
        const { resId, resDescription, resPermissions } = response;
        this.input("description", resDescription);
        this.itemId = resId;
        this.permissions = resPermissions;
      } catch (error) {
        generateError(error);
      } finally {
        this.getLoading = false;
      }
    },
    async handleSubmit() {
      try {
        this.loading = true;
        const helpKey = generateCurrentRoute();
        const { description } = this.form;
        const response = await updateHelp(helpKey, this.itemId, description);
        const { message } = response;
        toastAlert(message);
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },

    handleToggleShouldEdit() {
      this.shouldEdit = !this.shouldEdit;
    },
  },
};
</script>
